module.exports = __webpack_public_path__ + "img/paper-ticket.ee4b415b.png";